import React from 'react'
import Svg from './Svg'
export const SvgContacts = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M4.52 0v23.804h17.853V0H4.52zm8.926 5.958a2.969 2.969 0 11-.002 5.938 2.969 2.969 0 01.002-5.938zm4.463 11.895H8.982v-1.488a2.976 2.976 0 012.976-2.975h2.976a2.975 2.975 0 012.975 2.975v1.488zM1.544 1.488h2.232v4.463H1.544V1.488zM1.544 7.438h2.232v4.464H1.544V7.438zM1.544 13.39h2.232v4.463H1.544V13.39zM1.544 19.341h2.232v4.463H1.544v-4.463z" />
  </Svg>
))
SvgContacts.isIcon = true
export default SvgContacts
